// This file is auto-generated

import deCH from './lascanach/de-CH.json';
import frCH from './lascanach/fr-CH.json';

const messages = { 'de-CH': deCH, 'fr-CH': frCH };

export default messages;
